import {Injectable} from "@angular/core";
import {HomeMeasurementStatus, MeasurementStatus} from "../found-measurement";
import {isEcgMeasurement, MeasurementType} from "../../measurement-models";
import {ReleaseToggleState} from "../../../tools/release-toggles/release-toggle-state";
import {ExternalAnalysisType} from "../../hospitals/edit-hospital/hospital.details";

@Injectable()
export class MeasurementDetailsService {

  private readonly processingStatuses: MeasurementStatus[] = ["UPLOADED", "READY_FOR_ANALYSIS", "PRE_ANALYSIS", "PRE_ANALYSED"];

  canEditMeasurement(status: MeasurementStatus): boolean {
    return status === "UPLOADED"
      || (
        ReleaseToggleState.getInstance().isReleased("EDIT_PATIENT_DATA_DURING_PROCESSING_614")
        && this.processingStatuses.includes(status)
      );
  }

  canEditHolterType(type: MeasurementType, status: MeasurementStatus): boolean {

    const nonEditableHolterTypeStatuses: MeasurementStatus[] = ["INITIATED"];

    return type === "HOLTER_ECG" && !nonEditableHolterTypeStatuses.includes(status);
  }

  private readonly repeatableStatuses: MeasurementStatus[] = ["UPLOADED", "READY_FOR_ANALYSIS", "INITIATED"];
  private readonly additionalStatusesFor546: MeasurementStatus[] = ["PRE_ANALYSIS", "PRE_ANALYSED", "READY_FOR_POST_ANALYSIS"];
  private readonly repeatableHomeStatuses: HomeMeasurementStatus[] = ["MAILED_TO_PATIENT", "RETURNED_FROM_PATIENT"];

  canRepeatMeasurement(status: MeasurementStatus, homeStatus: HomeMeasurementStatus | undefined): boolean {
    return homeStatus !== undefined
      && this.repeatableHomeStatuses.includes(homeStatus)
      && (this.repeatableStatuses.includes(status)
        || (
          ReleaseToggleState.getInstance().isReleased("REPEAT_MEASUREMENT_AT_ADDITIONAL_STATUSES_546")
          && this.additionalStatusesFor546.includes(status)
        ));
  }

  canRevertFromDone(status: MeasurementStatus, nurseDownloadedReport: boolean) {
    return status === "DONE"
      && (
        !nurseDownloadedReport
        || ReleaseToggleState
          .getInstance()
          .isReleased("REVERT_FROM_DONE_AFTER_NURSE_DOWNLOADS_REPORT_457")
      );
  }

  canReturnToPreanalysis(
    type: MeasurementType,
    status: MeasurementStatus,
    externalAnalysisType: ExternalAnalysisType | undefined
  ): boolean {
    return isEcgMeasurement(type)
      && status === "READY_FOR_ANALYSIS"
      && externalAnalysisType === "CAS";
  }
}
